import React from 'react';

const HandTapIcon = (props: object) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 8.90625C7.5 7.29009 8.14202 5.74012 9.28482 4.59732C10.4276 3.45452 11.9776 2.8125 13.5938 2.8125C15.2099 2.8125 16.7599 3.45452 17.9027 4.59732C19.0455 5.74012 19.6875 7.29009 19.6875 8.90625"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.43754 26.25L5.00161 20.3906C4.69571 19.8526 4.61504 19.2154 4.7772 18.6181C4.93936 18.0208 5.33118 17.5119 5.86717 17.2025C6.40315 16.893 7.03979 16.8081 7.63813 16.9663C8.23648 17.1245 8.74797 17.513 9.06098 18.0469L11.25 21.5625V8.90625C11.25 8.28465 11.497 7.68851 11.9365 7.24897C12.3761 6.80943 12.9722 6.5625 13.5938 6.5625C14.2154 6.5625 14.8115 6.80943 15.2511 7.24897C15.6906 7.68851 15.9375 8.28465 15.9375 8.90625V15.4688C15.9375 14.8471 16.1845 14.251 16.624 13.8115C17.0636 13.3719 17.6597 13.125 18.2813 13.125C18.9029 13.125 19.499 13.3719 19.9386 13.8115C20.3781 14.251 20.625 14.8471 20.625 15.4688V17.3438C20.625 16.7221 20.872 16.126 21.3115 15.6865C21.7511 15.2469 22.3472 15 22.9688 15C23.5904 15 24.1865 15.2469 24.6261 15.6865C25.0656 16.126 25.3125 16.7221 25.3125 17.3438V21.5625C25.3125 24.375 24.375 26.25 24.375 26.25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HandTapIcon;
